import { useDispatch, useSelector } from "react-redux";
import { addPopularMovies } from "../store/slices/moviesSlice";
import { useEffect, useCallback } from "react";
import { API_OPTIONS } from "../utils/constants";
import { RootState } from "../store";

const usePopularMovies = () => {
  const dispatch = useDispatch();
  const popularMovies = useSelector((store: RootState) => store.movies.popularMovies);

  const getPopularMovies = useCallback(async () => {
    try {
      const data = await fetch(
        "https://api.themoviedb.org/3/movie/popular?page=1",
        API_OPTIONS
      );
      const json = await data.json();
      dispatch(addPopularMovies(json.results));
    } catch (error) {
      console.error("Error fetching popular movies:", error);
    }
  }, [dispatch]);

  useEffect(() => {
    if (!popularMovies) getPopularMovies();
  }, [popularMovies, getPopularMovies]);
};

export default usePopularMovies;
